import { Route } from 'react-router-dom';
import { route } from 'react-router-typesafe-routes/dom';

export const ROUTES = {
    COACH: route('coach', {}),
};

async function getLazyTutorbotComponent() {
    const { CoachPage } = await import(/* webpackPrefetch: true */ './components/CoachPage');

    return {
        Component: () => <CoachPage />,
    };
}

export function getCoachRoutes() {
    return <Route path={ROUTES.COACH.relativePath} lazy={getLazyTutorbotComponent} />;
}
